// extracted by mini-css-extract-plugin
export default {"modal":"EqASL8","list":"cyCsP1","item":"xV6fYP","icon":"kjHO65","itemTitle":"pbV1DR","subList":"yI5Rsf","itemText":"ibzho3","button":"I1R3gw"};